import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import {
  vacationApplicationSupervisorApi,
  VacationSupervisorPaginated,
} from 'app/services/edpApiV1/supervisor/vacationApplication';

interface TInitialState extends VacationSupervisorPaginated {
  loading: boolean;
  success: boolean;
  error?: string;
}

const initialState: TInitialState = {
  data: [],
  pagination: { page: 1, size: 10, total: 0 },
  loading: false,
  success: false,
};

export const vacationApplicationSupervisorSlice = createSlice({
  name: 'vacationApplicationSupervisor',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        vacationApplicationSupervisorApi.endpoints.vacationsDeputy.matchFulfilled,
        (state, { payload }: PayloadAction<VacationSupervisorPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(vacationApplicationSupervisorApi.endpoints.vacationsDeputy.matchRejected, () => initialState)
      .addMatcher(vacationApplicationSupervisorApi.endpoints.vacationsDeputy.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationApplicationSupervisorApi.endpoints.vacationsActing.matchFulfilled,
        (state, { payload }: PayloadAction<VacationSupervisorPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(vacationApplicationSupervisorApi.endpoints.vacationsActing.matchRejected, () => initialState)
      .addMatcher(vacationApplicationSupervisorApi.endpoints.vacationsActing.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        vacationApplicationSupervisorApi.endpoints.vacationsSupervisor.matchFulfilled,
        (state, { payload }: PayloadAction<VacationSupervisorPaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(vacationApplicationSupervisorApi.endpoints.vacationsSupervisor.matchRejected, () => initialState)
      .addMatcher(vacationApplicationSupervisorApi.endpoints.vacationsSupervisor.matchPending, state => {
        state.loading = true;
        state.success = false;
      });
  },
});

const vacationApplicationSupervisor = (state: RootState) =>
  state.entities.supervisor.vacationApplicationSupervisorReducer;
export const getVacationApplicationSupervisor = createSelector(vacationApplicationSupervisor, state => state);

export const actions = vacationApplicationSupervisorSlice.actions;
export const reducer = vacationApplicationSupervisorSlice.reducer;
